import React from 'react';
import {
	Create,
	Datagrid,
	Edit,
	EditButton,
	List,
	ReferenceField,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput,
	TextField,
} from 'react-admin';

import {
	WithMasterPermissions,
} from '../DataProviderExtension/authExtension';
import UserProfileField from '../components/UserProfileField';

const EditTradeUnionForm = () => {
	return (
		<SimpleForm>
			<TextField label="Id" source="id" />
			<ReferenceField label="Имя пользователя" source="parseUser.id" reference="User" link={false}>
				<TextField source="username" />
			</ReferenceField>
			<ReferenceField label="ППО" source="tradeUnion.id" reference="TradeUnion">
				<TextField source="shortTitle" />
			</ReferenceField>
		</SimpleForm>
	);
};

export const editTradeUnionAdmin = (props) => {
	return (
		<Edit {...props}>
			<EditTradeUnionForm />
		</Edit>
	);
};

export const CreateTradeUnionAdminForm = () => {
	return (
		<SimpleForm>
			<TextInput label="id пользователя" source="parseUser.id" />
			<ReferenceInput source="tradeUnion.id" reference="TradeUnion">
				<SelectInput optionText="shortTitle" label="ППО" />
			</ReferenceInput>
		</SimpleForm>
	);
};

export const createTradeUnionAdmin = (props) => {
	return (
		<Create {...props}>
			<CreateTradeUnionAdminForm />
		</Create>
	);
};

export const listTradeUnionAdmin = (props) => {
	return (
		<List {...props} title="Администраторы ППО">
			<Datagrid rowClick="edit">
				<TextField label="Id" source="id" />
				<UserProfileField label="Пользователь" source="parseUser.id" />
				<ReferenceField label="ППО" source="tradeUnion.id" reference="TradeUnion">
					<TextField source="shortTitle" />
				</ReferenceField>
				<WithMasterPermissions>
					<EditButton />
				</WithMasterPermissions>
			</Datagrid>
		</List>
	);
};
